/// <reference path="../typings/index.d.ts" />
namespace App {
  export class UtilsEA {
    public static ItemCardAssetId = {
      "0": "NONE",
      "7": "CONTRACT_PLAYER",
      "8": "CONTRACT_MANAGER",
      "9": "HEALING",
      "32": "MANAGER_LEAGUE",
      "34": "POSITION_MODIFIER",
      "35": "MANAGER_FORMATION",
      "50": "PLAYSTYLE_PLAYER",
      "51": "PLAYSTYLE_GK",
      "NONE": 0,
      "CONTRACT_PLAYER": 7,
      "CONTRACT_MANAGER": 8,
      "HEALING": 9,
      "MANAGER_LEAGUE": 32,
      "POSITION_MODIFIER": 34,
      "MANAGER_FORMATION": 35,
      "PLAYSTYLE_PLAYER": 50,
      "PLAYSTYLE_GK": 51
    }

    constructor() {

    }

    public static getPosicoesFiltrosDataTable(): any[] {
      return [
        {
          label: "GK (GOL)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "GK";
          }
        },
        {
          label: "CB (ZAG)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "CB";
          }
        },
        {
          label: "RWB (ADD)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "RWB";
          }
        },
        {
          label: "RB (LD)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "RB";
          }
        },
        {
          label: "LB (LE)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "LB";
          }
        },
        {
          label: "CDM (VOL)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "CDM";
          }
        },
        {
          label: "RM (MD)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "RM";
          }
        },
        {
          label: "CM (MC)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "CM";
          }
        },
        {
          label: "LM (ME)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "LM";
          }
        },
        {
          label: "CAM (MEI)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "CAM";
          }
        },
        {
          label: "RF (PD)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "RF";
          }
        },
        {
          label: "CF (SA)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "CF";
          }
        },
        {
          label: "LF (MAE)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "LF";
          }
        },
        {
          label: "RW (PD)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "RW";
          }
        },
        {
          label: "ST (ATA)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "ST";
          }
        },
        {
          label: "LW (PE)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == "LW";
          }
        },
        {
          label: "undefined (indefinido)",
          value: function (obj: IItemListagem, rowIdx: any) {
            return obj.preferredPositionName == null || obj.preferredPositionName == "";
          }
        }
      ]
    }

    public static getPaisesFiltrosDataTable(): any[] {
      return [
        { label: "Argentina", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "52"; } },
        { label: "Brasil", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "54"; } },
        { label: "Inglaterra", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "14"; } },
        { label: "França", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "18"; } },
        { label: "Alemanha", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "21"; } },
        { label: "Holanda", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "34"; } },
        { label: "Itália", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "27"; } },
        { label: "Portugal", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "38"; } },
        { label: "Espanha", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "45"; } },
        { label: "A. Saudita", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "183"; } },
        { label: "Afeganistão", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "149"; } },
        { label: "África S.", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "140"; } },
        { label: "Albânia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "1"; } },
        { label: "Andorra", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "2"; } },
        { label: "Angola", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "98"; } },
        { label: "Antígua B.", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "63"; } },
        { label: "Antilhas H.", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "85"; } },
        { label: "Argélia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "97"; } },
        { label: "Armênia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "3"; } },
        { label: "Austrália", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "195"; } },
        { label: "Áustria", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "4"; } },
        { label: "Azerbaijão", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "5"; } },
        { label: "Barbados", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "66"; } },
        { label: "Bélgica", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "7"; } },
        { label: "Belize", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "67"; } },
        { label: "Benin", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "99"; } },
        { label: "Bermuda", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "68"; } },
        { label: "Bielorrússia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "6"; } },
        { label: "Bolívia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "53"; } },
        { label: "Bósnia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "8"; } },
        { label: "Bulgária", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "9"; } },
        { label: "Burk. Fasso", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "101"; } },
        { label: "Burundi", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "102"; } },
        { label: "C. do Norte", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "166"; } },
        { label: "C. Marfim", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "108"; } },
        { label: "Cabo Verde", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "104"; } },
        { label: "Camarões", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "103"; } },
        { label: "Canadá", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "70"; } },
        { label: "Cazaquistão", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "165"; } },
        { label: "Chade", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "106"; } },
        { label: "Chile", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "55"; } },
        { label: "China", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "155"; } },
        { label: "Chipre", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "11"; } },
        { label: "Colômbia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "56"; } },
        { label: "Comores", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "214"; } },
        { label: "Congo", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "107"; } },
        { label: "Coreia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "167"; } },
        { label: "Costa Rica", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "72"; } },
        { label: "Croácia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "10"; } },
        { label: "Cuba", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "73"; } },
        { label: "Dinamarca", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "13"; } },
        { label: "EAU", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "190"; } },
        { label: "Egito", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "111"; } },
        { label: "El Salvad.", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "76"; } },
        { label: "Equador", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "57"; } },
        { label: "Eritreia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "113"; } },
        { label: "Escócia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "42"; } },
        { label: "Eslováquia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "43"; } },
        { label: "Eslovênia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "44"; } },
        { label: "Estônia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "208"; } },
        { label: "Etiópia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "114"; } },
        { label: "EUA", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "95"; } },
        { label: "Fiji", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "197"; } },
        { label: "Filipinas", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "181"; } },
        { label: "Finlândia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "17"; } },
        { label: "Gabão", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "115"; } },
        { label: "Gâmbia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "116"; } },
        { label: "Gana", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "117"; } },
        { label: "Geórgia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "20"; } },
        { label: "Gibraltar", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "205"; } },
        { label: "Granada", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "77"; } },
        { label: "Grécia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "22"; } },
        { label: "Guam", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "157"; } },
        { label: "Guatemala", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "78"; } },
        { label: "Guiana", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "79"; } },
        { label: "Guiné", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "118"; } },
        { label: "Guiné E.", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "112"; } },
        { label: "Guiné-B.", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "119"; } },
        { label: "Haiti", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "80"; } },
        { label: "Honduras", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "81"; } },
        { label: "Hong Kong", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "158"; } },
        { label: "Hungria", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "23"; } },
        { label: "I. Faroe", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "16"; } },
        { label: "Índia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "159"; } },
        { label: "Irã", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "161"; } },
        { label: "Iraque", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "162"; } },
        { label: "Irlanda", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "25"; } },
        { label: "Irlanda N.", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "35"; } },
        { label: "Islândia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "24"; } },
        { label: "Israel", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "26"; } },
        { label: "Jamaica", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "82"; } },
        { label: "Japão", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "163"; } },
        { label: "Jordânia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "164"; } },
        { label: "Kosovo", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "219"; } },
        { label: "Letônia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "28"; } },
        { label: "Líbano", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "171"; } },
        { label: "Libéria", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "122"; } },
        { label: "Líbia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "123"; } },
        { label: "Lituânia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "30"; } },
        { label: "Luxemburgo", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "31"; } },
        { label: "Maced. do Norte", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "19"; } },
        { label: "Madagascar", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "124"; } },
        { label: "Malásia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "173"; } },
        { label: "Malauí", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "125"; } },
        { label: "Mali", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "126"; } },
        { label: "Malta", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "32"; } },
        { label: "Marrocos", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "129"; } },
        { label: "Maurício", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "128"; } },
        { label: "Mauritânia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "127"; } },
        { label: "México", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "83"; } },
        { label: "Moçambique", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "130"; } },
        { label: "Moldávia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "33"; } },
        { label: "Montenegro", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "15"; } },
        { label: "Montserrat", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "84"; } },
        { label: "N. Zelândia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "198"; } },
        { label: "Namíbia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "131"; } },
        { label: "Níger", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "132"; } },
        { label: "Nigéria", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "133"; } },
        { label: "Noruega", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "36"; } },
        { label: "P. de Gales", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "50"; } },
        { label: "Palestina", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "180"; } },
        { label: "Panamá", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "87"; } },
        { label: "Paraguai", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "58"; } },
        { label: "Peru", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "59"; } },
        { label: "Polônia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "37"; } },
        { label: "Porto Rico", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "88"; } },
        { label: "Quênia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "120"; } },
        { label: "R. Tcheca", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "12"; } },
        { label: "RCA", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "105"; } },
        { label: "RD do Congo", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "110"; } },
        { label: "Rep. Dom.", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "207"; } },
        { label: "Romênia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "39"; } },
        { label: "Rússia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "40"; } },
        { label: "S. C. Neves", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "89"; } },
        { label: "Santa Lúcia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "90"; } },
        { label: "Senegal", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "136"; } },
        { label: "Serra Leoa", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "138"; } },
        { label: "Sérvia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "51"; } },
        { label: "Síria", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "186"; } },
        { label: "Sudão", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "141"; } },
        { label: "Sudão do Sul", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "218"; } },
        { label: "Suécia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "46"; } },
        { label: "Suíça", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "47"; } },
        { label: "Suriname", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "92"; } },
        { label: "Tailândia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "188"; } },
        { label: "Taipé Chinês", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "213"; } },
        { label: "Tanzânia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "143"; } },
        { label: "Togo", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "144"; } },
        { label: "Trinidad", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "93"; } },
        { label: "Tunísia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "145"; } },
        { label: "Turquia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "48"; } },
        { label: "Ucrânia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "49"; } },
        { label: "Uganda", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "146"; } },
        { label: "Uruguai", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "60"; } },
        { label: "Uzbequistão", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "191"; } },
        { label: "Venezuela", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "61"; } },
        { label: "Vietnã", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "192"; } },
        { label: "Zâmbia", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "147"; } },
        { label: "Zimbábue", value: function (obj: IItemListagem, rowIdx: any) { return obj.nationId == "148"; } }
      ]
    }
  }
}
